<script setup lang="ts">
/* The shell. Which face you get is the router's business: the front door for a guest, the room once
   she knows you. */
</script>

<template>
  <RouterView />
</template>
